import { ModalTitle } from "./Title";
import { ModalDescription } from "./Description";
import { ModalLoadingOverlay } from "./LoadingOverlay";

export const Modal = {
  Title: ModalTitle,
  Description: ModalDescription,
  LoadingOverlay: ModalLoadingOverlay,
};
